export default __webpack_public_path__ + "static/desk5000-7f377f914959188223775e8c03026a24.webp";